import React from 'react';
import PropTypes from 'prop-types';
import Title from './Title';
import Description from './Description';

const TitleDescription = ({ t, description, title, setValue }) => (
  <>
    <Title t={t} title={title} setValue={setValue} />
    <Description t={t} description={description} setValue={setValue} />
  </>
);

TitleDescription.propTypes = {
  setValue: PropTypes.func,
  t: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
};

TitleDescription.defaultProps = {
  setValue: () => {},
  t: () => {},
  title: '',
  description: '',
};

export default TitleDescription;
